import {
  ENDPOINT_ROOT,
  ENDPOINT_WISHLISTS_CATEGORIES,
} from '@/common/constants';
import axiosAuth from '@/common/interceptors/axios.AuthInterceptor';

// eslint-disable-next-line camelcase
const postWishlistsCategory = ({ name, parent_id }) => {
  const params = {
    name,
    parent_id,
  };

  return axiosAuth
    .post(`${ENDPOINT_ROOT}/${ENDPOINT_WISHLISTS_CATEGORIES}`, params)
    .then((res) => res.data);
};

export default postWishlistsCategory;
